import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {Grandmaster} from "lo-bahamut";
import { SharedModule } from '../_shared/shared.module';
import { CustomCarouselModule } from '../_shared/custom-carousel/custom-carousel.module';
import { ComingSoonModule } from '../coming-soon/coming-soon.module';
import {SearchResultsV2Component} from "./search-results-v2.component";
import {PrintSearchResultsModule} from "../search-results/print-search-results/print-search-results.module";

@NgModule({
  declarations: [SearchResultsV2Component],
    imports: [
        ComingSoonModule,
        CommonModule,
        SharedModule,
        CustomCarouselModule,
        Grandmaster,
        PrintSearchResultsModule
    ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SearchResultsV2Module {}
